/**
 * Parses GPX XML text and extracts waypoints/coordinates.
 * @param {string} text - GPX XML content
 * @returns {Array<{lat: number, lng: number, name?: string}>} Array of coordinates
 */
export const parseGPXFromText = (text) => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(text, 'text/xml');

  const parserError = xmlDoc.querySelector('parsererror');
  if (parserError) {
    throw new Error('Failed to parse GPX file. Invalid XML.');
  }

  const coordinates = [];

  const pushIfValid = (lat, lon, name) => {
    const title = typeof name === 'string' ? name.trim() : '';
    if (
      !Number.isNaN(lat) &&
      !Number.isNaN(lon) &&
      title.length > 0
    ) {
      const exists = coordinates.some(
        (c) => c.lat === lat && c.lng === lon
      );
      if (!exists) {
        coordinates.push({
          lat,
          lng: lon,
          name: title,
        });
      }
    }
  };

  xmlDoc.querySelectorAll('wpt').forEach((wpt) => {
    const lat = parseFloat(wpt.getAttribute('lat'));
    const lon = parseFloat(wpt.getAttribute('lon'));
    const nameEl = wpt.querySelector('name');
    pushIfValid(lat, lon, nameEl ? nameEl.textContent : null);
  });

  xmlDoc.querySelectorAll('trkpt').forEach((trkpt) => {
    const lat = parseFloat(trkpt.getAttribute('lat'));
    const lon = parseFloat(trkpt.getAttribute('lon'));
    const nameEl = trkpt.querySelector('name');
    pushIfValid(lat, lon, nameEl ? nameEl.textContent : null);
  });

  xmlDoc.querySelectorAll('rtept').forEach((rtept) => {
    const lat = parseFloat(rtept.getAttribute('lat'));
    const lon = parseFloat(rtept.getAttribute('lon'));
    const nameEl = rtept.querySelector('name');
    pushIfValid(lat, lon, nameEl ? nameEl.textContent : null);
  });

  if (coordinates.length === 0) {
    throw new Error('GPX faile nerasta koordinačių su pavadinimu.');
  }

  return coordinates;
};

/**
 * Parses a GPX file and extracts waypoints/coordinates
 * @param {File} file - The GPX file
 * @returns {Promise<Array<{lat: number, lng: number, name?: string}>>} Array of coordinates
 */
export const parseGPX = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        resolve(parseGPXFromText(e.target.result));
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = () => reject(new Error('Failed to read GPX file.'));
    reader.readAsText(file);
  });
};

/**
 * Formats coordinates to string format used in the system
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @returns {string} Formatted coordinates string
 */
export const formatCoordinates = (lat, lng) => {
  return `${lat}, ${lng}`;
};
